import React from 'react'

export default function CollectionIcon() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            enableBackground="new 0 0 50 50"
            height="50"
            viewBox="0 0 50 50"
            width="50"
        >
            <path d="m43.6 3.7h-29.3c-1.5 0-2.8 1.2-2.8 2.8v29.3c0 1.5 1.2 2.8 2.8 2.8h29.3c1.5 0 2.8-1.2 2.8-2.8v-29.4c0-1.5-1.3-2.7-2.8-2.7zm.8 32.1c0 .4-.3.8-.8.8h-29.3c-.4 0-.8-.3-.8-.8v-29.4c0-.4.3-.8.8-.8h29.3c.4 0 .8.3.8.8z" />
            <path d="m36.5 43.6c0 .4-.3.8-.8.8h-29.3c-.4 0-.8-.3-.8-.8v-29.3c0-.4.3-.8.8-.8h3.2v-2h-3.2c-1.5 0-2.8 1.2-2.8 2.8v29.3c0 1.5 1.2 2.8 2.8 2.8h29.3c1.5 0 2.8-1.2 2.8-2.8v-3.1h-2z" />
            <path d="m38.3 17.4-5.8-.8-2.5-5.2c-.2-.4-.6-.7-1-.7s-.8.2-1 .7l-2.6 5.2-5.8.8c-.4.1-.8.4-.9.8s0 .9.3 1.2l4.2 4.1-1 5.7c-.1.3 0 .7.3.9.2.3.5.4.9.4h.3l5.4-2.8 5.1 2.7.3.1h.2c.3 0 .7-.2.9-.4.2-.3.3-.6.3-.9l-1-5.7 4.2-4.1c.3-.3.4-.8.3-1.2s-.6-.7-1.1-.8zm-5.2 5c-.3.3-.4.6-.3 1l.8 4.5-4-2.1c-.2-.1-.4-.1-.5-.1h-.3l-4.3 2.2.8-4.5c.1-.4-.1-.8-.3-1l-3.3-3.2 4.5-.7c.4-.1.7-.3.9-.6l2-4.1 2 4.1c.2.3.5.6.9.6l4.5.7z" />
        </svg>
    )
}
